
import { Link } from 'react-router-dom';
import { callout } from '../../style/article';

export default function FundraiserCallout({
  fundraiserTag,
}: {
  fundraiserTag: string;
}) {
  return (
    <div css={{ margin: '16px 0' }}>
      <div css={callout}>
        <p>
          This update was made possible by everyone who contributed to{' '}
          <Link to={`/fundraisers/${fundraiserTag}`}>this Wren fundraiser</Link>
          . We appreciate your support!
        </p>
      </div>
    </div>
  );
}
